module.exports = __webpack_public_path__ + "static/media/logo.605ce02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/style/images/logo.png
// module id = 2650
// module chunks = 0